import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/main.scss';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import { format as formatDate, formatRelative, formatDistance, isDate } from 'date-fns';
import { ru, enUS } from 'date-fns/locale';
import log from './utils/logger';

import { RepositoryProvider } from './store/RepositoryProvider';
import { UserProvider } from './store/UserProvider';

import common_ru from './translations/ru/common.json';
import common_en from './translations/en/common.json';
import auth_ru from './translations/ru/auth.json';
import auth_en from './translations/en/auth.json';
import account_ru from './translations/ru/account.json';
import account_en from './translations/en/account.json';
import excursion_ru from './translations/ru/excursion.json';
import excursion_en from './translations/en/excursion.json';
import order_ru from './translations/ru/order.json';
import order_en from './translations/en/order.json';
import sale_ru from './translations/ru/sale.json';
import sale_en from './translations/en/sale.json';
import schedule_ru from './translations/ru/schedule.json';
import schedule_en from './translations/en/schedule.json';
import boarding_ru from './translations/ru/boarding.json';
import boarding_en from './translations/en/boarding.json';
import cashbox_ru from './translations/ru/cashbox.json';
import cashbox_en from './translations/en/cashbox.json';
import salary_ru from './translations/ru/salary.json';
import salary_en from './translations/en/salary.json';
import route_ru from './translations/ru/route.json';
import route_en from './translations/en/route.json';
import collection_ru from './translations/ru/collection.json';
import collection_en from './translations/en/collection.json';
import my_collection_ru from './translations/ru/my_collection.json';
import my_collection_en from './translations/en/my_collection.json';
import ticket_ru from './translations/ru/ticket.json';
import ticket_en from './translations/en/ticket.json';
import refund_ru from './translations/ru/refund.json';
import refund_en from './translations/en/refund.json';
import ErrorBoundary from './screen/ErrorBoundary';
import { CookiesProvider } from 'react-cookie';

const locales = { ru, enUS };

i18next.init({
  lng: 'ru',
  fallbackLng: 'en',
  resources: {
    ru: {
      common: common_ru,
      auth: auth_ru,
      account: account_ru,
      excursion: excursion_ru,
      order: order_ru,
      sale: sale_ru,
      schedule: schedule_ru,
      boarding: boarding_ru,
      cashbox: cashbox_ru,
      salary: salary_ru,
      route: route_ru,
      collection: collection_ru,
      my_collection: my_collection_ru,
      ticket: ticket_ru,
      refund: refund_ru
    },
    en: {
      common: common_en,
      auth: auth_en,
      account: account_en,
      excursion: excursion_en,
      order: order_en,
      sale: sale_en,
      schedule: schedule_en,
      boarding: boarding_en,
      cashbox: cashbox_en,
      salary: salary_en,
      route: route_en,
      collection: collection_en,
      my_collection: my_collection_en,
      ticket: ticket_en,
      refund: refund_en
    }
  },
  interpolation: {
    escapeValue: false,

    format: (value, format, lng) => {
      let text = value;

      if (isDate(value)) {
        const locale = locales[lng];

        if (format === "short") {
          text = formatDate(value, "P", { locale });
        } else if (format === "long") {
          text = formatDate(value, "PPPP", { locale });
        } else if (format === "relative") {
          text = formatRelative(value, new Date(), { locale });
        } else if (format === "ago") {
          text = formatDistance(value, new Date(), { locale, addSuffix: true });
        } else {
          text = formatDate(value, format, { locale });
        }
      }

      return text;
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <CookiesProvider>
      <I18nextProvider i18n={i18next}>
        <RepositoryProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </RepositoryProvider>
      </I18nextProvider>
    </CookiesProvider>
  </ErrorBoundary>
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(log.info);
